require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-chana-daltadka.json") })
        }
      }, "path---recipes-chana-daltadka");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-chana-daltadka!./.cache/json/recipes-chana-daltadka.json
// module id = 727
// module chunks = 231608221292675